module.exports = __webpack_public_path__ + "img/tree_right_layout_icon.04d44d4b.svg";